function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { media, themeGet } from "sprout-ui-theme";
import { createElement, useCallback, isValidElement } from "react";
import { Text } from "sprout-ui-primitives";
import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import { Button } from "sprout-ui-dom/dist/Button";
import { ACTIONS, useNavigationListContext } from "..";
const MenuItemButton = styled(Button)`
  position: relative;
  width: 100%;

  ${({ $variant  })=>$variant === "tile" && css`
      border-radius: 8px;
      padding: 16px;
      background: ${themeGet("colors.white.12")};

      flex-direction: column;
      justify-content: flex-start;

      ${media.up("medium", "pointer")} {
        padding: 24px 8px 14px;
      }
    `}

  ${({ $variant  })=>$variant !== "tile" && css`
      display: flex;
      align-items: center;
      text-align: left;
      padding: 8px 16px;
      font-size: ${themeGet("fontSizes.1")}px;
    `}

  ${({ $variant  })=>$variant === "pill" && css`
      border-radius: 8px;
      background: ${themeGet("colors.white.12")};
      padding: 8px 32px 8px 16px;
    `}

  color: ${themeGet("colors.white.100")};
  :disabled {
    color: ${themeGet("colors.white.40")};
  }

  :not(:disabled) {
    &[aria-selected="true"] {
      background: ${themeGet("colors.black.16")};
    }

    ${media.up("medium", "pointer")} {
      :hover {
        background: ${themeGet("colors.black.16")};
      }
    }

    :active {
      background: ${themeGet("colors.black.24")};
    }
  }
`;
const MenuItemLabel = styled(Text)`
  ${({ $variant  })=>$variant === "tile" && css`
      margin-top: 2px;
    `}

  ${({ $keybinding , $variant  })=>$variant === undefined && $keybinding && css`
      ${media.up("medium", "pointer")} {
        margin-right: 16px;
      }
    `}
`;
const MenuItemKeybinding = styled(Text)`
  display: none;

  ${media.up("medium", "pointer")} {
    display: initial;
  }

  ${({ $variant  })=>$variant !== undefined && css`
      position: absolute;
      top: 4px;
      right: 12px;

      pointer-events: auto;
    `}

  ${({ $variant  })=>$variant === undefined && css`
      flex: none;
      min-width: 20px;
      border-radius: 4px;
      background: ${themeGet("colors.white.12")};
      padding: 0 4px;
    `}
`;
const MenuItem = (props)=>{
    const { _blank , truncate =false , variant , keybindingTitle , to , href , onClick , disabled  } = props, rest = _objectWithoutProperties(props, [
        "_blank",
        "truncate",
        "variant",
        "keybindingTitle",
        "to",
        "href",
        "onClick",
        "disabled"
    ]);
    let as = {};
    if (to) as = {
        as: Link,
        to
    };
    else if (href) {
        as = {
            as: "a",
            href
        };
        if (_blank) as = _objectSpread({}, as, {
            target: "_blank",
            rel: "noopener noreferrer"
        });
    }
    const isTile = variant === "tile";
    let action;
    let actionSpec;
    let iconProp;
    let label;
    let keybinding;
    let activeItem;
    if ("action" in props) {
        action = props.action;
        actionSpec = ACTIONS.find((a)=>a.command === props.action);
        var _icon;
        iconProp = (_icon = props.icon) !== null && _icon !== void 0 ? _icon : actionSpec === null || actionSpec === void 0 ? void 0 : actionSpec.icon;
        var _label;
        label = (_label = props.label) !== null && _label !== void 0 ? _label : actionSpec === null || actionSpec === void 0 ? void 0 : actionSpec.label;
        keybinding = actionSpec === null || actionSpec === void 0 ? void 0 : actionSpec.keybindingForDisplay;
        activeItem = props.activeItem;
    } else {
        label = props.label;
        iconProp = props.icon;
        keybinding = props.keybinding;
    }
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const { dispatchCommand  } = useNavigationListContext();
    const handleClick = useCallback((event)=>{
        if (onClick) onClick(event);
        if (action) dispatchCommand(action, activeItem);
    }, [
        action,
        activeItem,
        dispatchCommand,
        onClick
    ]);
    const icon = iconProp ? /*#__PURE__*/ isValidElement(iconProp) ? iconProp : /*#__PURE__*/ createElement(iconProp) : undefined;
    return /*#__PURE__*/ _jsxs(MenuItemButton, _objectSpread({
        $variant: variant,
        disabled: disabled,
        onClick: handleClick
    }, as, rest, {
        children: [
            icon,
            /*#__PURE__*/ _jsx(MenuItemLabel, {
                className: "MenuItemLabel",
                ml: isTile || !iconProp ? undefined : 3,
                as: "span",
                fontSize: "15px",
                fontWeight: "medium",
                lineHeight: "24px",
                textAlign: isTile ? "center" : undefined,
                truncate: isTile ? false : truncate,
                $keybinding: !!keybinding,
                $variant: variant,
                children: label
            }),
            keybinding && /*#__PURE__*/ _jsx(MenuItemKeybinding, {
                color: "white.70",
                ml: isTile ? undefined : "auto",
                $variant: variant,
                title: keybindingTitle,
                as: "span",
                fontWeight: "bold",
                fontSize: "13px",
                textAlign: "center",
                children: keybinding
            })
        ]
    }));
};
export default MenuItem;
